import {IOGateway} from '../../gateway';

function isExactMatch(matcher: IOGateway.Filtering.Matcher): matcher is IOGateway.Filtering.ExactMatch {
    return typeof matcher === 'string';
}

export function valueMatches(lhs: IOGateway.Filtering.Matcher, rhs?: unknown): boolean {
    if (isExactMatch(lhs)) {
        return lhs === rhs
    } else {
        if (typeof rhs === 'string') {
            return lhs.test(rhs);
        }
        return false;
    }
}

export function valuesMatch(matchers: IOGateway.Filtering.Matcher[], value?: string): boolean {
    for (const matcher of matchers) {
        if (valueMatches(matcher, value)) {
            return true;
        }
    }
    return false;
}
//https://cljs.github.io/api/syntax/regex
const CLOJURESCRIPT_REGEX = /^#(\(\?(?<flags>[im]*)\))?(?<pattern>.*)$/;

const JAVASCRIPT_REGEX = /^\/(?<pattern>(?:[^/\\]|\\.)+)\/(?<flags>[gimsuyd]*)$/;

export function regexify(expression: IOGateway.Filtering.Matcher): IOGateway.Filtering.Matcher {
    if (typeof expression === 'string') {
        let groups = JAVASCRIPT_REGEX.exec(expression)?.groups;
        groups ??= CLOJURESCRIPT_REGEX.exec(expression)?.groups;

        if (groups?.pattern) {
            return new RegExp(groups.pattern, groups.flags ?? '');
        }

    }
    return expression;
}
